import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { getRuntimeConfig } from '../lib/config';

function getSessionId(): string {
  try {
    let id = sessionStorage.getItem('_sid');
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem('_sid', id);
    }
    return id;
  } catch {
    return 'unknown';
  }
}

export function useAnalytics() {
  const location = useLocation();
  const { user } = useAuthStore();
  const lastPath = useRef('');

  useEffect(() => {
    if (location.pathname === lastPath.current) return;
    lastPath.current = location.pathname;

    let apiUrl = '';
    try { apiUrl = getRuntimeConfig().apiUrl; } catch { return; } // config not ready yet

    const payload = {
      page: location.pathname,
      referrer: document.referrer || null,
      sessionId: getSessionId(),
      userId: user?.userId ?? null,
      displayName: user?.displayName ?? null,
    };

    // Fire-and-forget: don't await, don't show errors to user
    fetch(`${apiUrl}/v1/analytics/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  // Track on path change OR when user authenticates (to attach userId retroactively)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, user?.userId]);
}
